import { render, staticRenderFns } from "./InsertImageModal.vue?vue&type=template&id=3abd78a0"
import script from "./InsertImageModal.vue?vue&type=script&lang=js"
export * from "./InsertImageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports